package com.corbettcode.allaboutrocks.components.sections

import androidx.compose.runtime.*
import com.corbettcode.allaboutrocks.components.widgets.DropdownAction
import com.corbettcode.allaboutrocks.components.widgets.DropdownMenuComponent
import com.corbettcode.allaboutrocks.components.widgets.DropdownSubMenu
import com.varabyte.kobweb.browser.dom.ElementTarget
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.CloseIcon
import com.varabyte.kobweb.silk.components.icons.HamburgerIcon
import com.varabyte.kobweb.silk.components.icons.MoonIcon
import com.varabyte.kobweb.silk.components.icons.SunIcon
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.overlay.Overlay
import com.varabyte.kobweb.silk.components.overlay.OverlayVars
import com.varabyte.kobweb.silk.components.overlay.PopupPlacement
import com.varabyte.kobweb.silk.components.overlay.Tooltip
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*
import com.corbettcode.allaboutrocks.components.widgets.IconButton
import com.corbettcode.allaboutrocks.toSitePalette
import com.corbettcode.allaboutrocks.utility.textColor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText

val NavHeaderStyle = CssStyle.base {
    Modifier.fillMaxWidth().padding(1.cssRem)
}

@Deprecated("do not use")
@Composable
private fun NavLink(path: String, text: String) {
    Link(path, text, variant = UndecoratedLinkVariant.then(UncoloredLinkVariant))
}

/**
 *
 */
@Composable
private fun MenuItem(
    selected: Boolean = false,
    text: @Composable () -> Unit,
    onClick: () -> Unit

) {
    Box(
        modifier = Modifier
            .onClick { onClick() }
    ) {
        text()
    }
}

@Composable
private fun MenuComponents(

) {
    val pageContext = rememberPageContext()
    fun navigateToPage(path: String) = pageContext.router.navigateTo(path)

    MenuItem(text = { SpanText("Home") }
        , onClick = { navigateToPage("/") })
    MenuItem(text = { TypesOfRocksDropdownMenu() }
        , onClick = {})
    MenuItem(text = { LearnIdentifyDropdownMenu() }
        , onClick = {})
    MenuItem(text = { SpanText("Awesome Places") }
        , onClick = { navigateToPage("/awesome-places") })
    MenuItem(text = { SpanText("Resources") }
        , onClick = { navigateToPage("/resources") })
    MenuItem(text = { SpanText("Contact Us") }
        , onClick = { navigateToPage("/contact-us") })
    MenuItem(text = { SpanText("About") }
        , onClick = { navigateToPage("/about") })
    ColorModeButton()
}
//
//@Composable
//private fun MenuItems() {
//    NavLink("/", "Home")
//    NavLink("/learn", "Learn")
//    NavLink("/about", "About")
//}

@Composable
private fun ColorModeButton() {
    var colorMode by ColorMode.currentState
    IconButton(onClick = { colorMode = colorMode.opposite },) {
        if (colorMode.isLight) MoonIcon() else SunIcon()
    }
    Tooltip(ElementTarget.PreviousSibling, "Toggle color mode", placement = PopupPlacement.BottomRight)
}

@Composable
private fun HamburgerButton(onClick: () -> Unit) {
    IconButton(onClick) {
        HamburgerIcon()
    }
}

@Composable
private fun CloseButton(onClick: () -> Unit) {
    IconButton(onClick) {
        CloseIcon()
    }
}

val SideMenuSlideInAnim = Keyframes {
    from {
        Modifier.translateX(100.percent)
    }

    to {
        Modifier
    }
}

// Note: When the user closes the side menu, we don't immediately stop rendering it (at which point it would disappear
// abruptly). Instead, we start animating it out and only stop rendering it when the animation is complete.
enum class SideMenuState {
    CLOSED
    , OPEN
    , CLOSING
    ;

    fun close() = when (this) {
        CLOSED -> CLOSED
        OPEN -> CLOSING
        CLOSING -> CLOSING
    }
}

@Composable
fun NavHeader() {
    Row(NavHeaderStyle.toModifier(), verticalAlignment = Alignment.CenterVertically) {
        //Link("https://kobweb.varabyte.com") {
            // Block display overrides inline display of the <img> tag, so it calculates centering better
            Image(
                "/All-About-Rocks-Logo.png"
                , "All About Rocks Logo"
                , Modifier
                    .height(2.cssRem)
                    .display(DisplayStyle.Block)
            )
        //}

        Spacer()

        Row(
            Modifier
                .gap(1.5.cssRem)
                .displayIfAtLeast(Breakpoint.MD)
            , verticalAlignment = Alignment.CenterVertically
        ) {
            MenuComponents()
//            MenuItems()
//            ColorModeButton()
        }

        Row(
            Modifier
                .fontSize(1.5.cssRem)
                .gap(1.cssRem)
                .displayUntil(Breakpoint.MD),
            verticalAlignment = Alignment.CenterVertically
        ) {
            var menuState by remember { mutableStateOf(SideMenuState.CLOSED) }

            ColorModeButton()
            HamburgerButton(onClick =  { menuState = SideMenuState.OPEN })

            if (menuState != SideMenuState.CLOSED) {
                SideMenu(
                    menuState
                    , close = { menuState = menuState.close() }
                    , onAnimationEnd = { if (menuState == SideMenuState.CLOSING) menuState = SideMenuState.CLOSED }
                )
            }
        }
    }
}

@Composable
private fun SideMenu(
    menuState: SideMenuState
    , close: () -> Unit
    , onAnimationEnd: () -> Unit
) {
    Overlay(
        Modifier
            .setVariable(OverlayVars.BackgroundColor, Colors.Transparent)
            .onClick { close() }
    ) {
        key(menuState) { // Force recompute animation parameters when close button is clicked
            Column(
                Modifier
                    .fillMaxHeight()
                    .width(clamp(8.cssRem, 33.percent, 10.cssRem))
                    .align(Alignment.CenterEnd)
                    // Close button will appear roughly over the hamburger button, so the user can close
                    // things without moving their finger / cursor much.
                    .padding(top = 1.cssRem, leftRight = 1.cssRem)
                    .gap(1.5.cssRem)
                    .backgroundColor(ColorMode.current.toSitePalette().nearBackground)
                    .animation(
                        SideMenuSlideInAnim.toAnimation(
                            duration = 200.ms
                            , timingFunction = if (menuState == SideMenuState.OPEN) AnimationTimingFunction.EaseOut else AnimationTimingFunction.EaseIn
                            , direction = if (menuState == SideMenuState.OPEN) AnimationDirection.Normal else AnimationDirection.Reverse
                            , fillMode = AnimationFillMode.Forwards
                        )
                    )
                    .borderRadius(topLeft = 2.cssRem)
                    .onClick { it.stopPropagation() }
                    .onAnimationEnd { onAnimationEnd() }
                , horizontalAlignment = Alignment.End
            ) {
                CloseButton(onClick = { close() })
                Column(
                    Modifier
                        .padding(right = 0.75.cssRem)
                        .gap(1.5.cssRem)
                        .fontSize(1.0.cssRem)
                    , horizontalAlignment = Alignment.End
                ) {
                    MenuComponents()
                }
            }
        }
    }
}


/**
 *
 *
 */
@Composable
private fun LearnIdentifyDropdownMenu() {

    val pageContext = rememberPageContext()
    val backgroundColor = if (ColorMode.current == ColorMode.LIGHT) Colors.White else Colors.Black
    //val textColor = if (ColorMode.current == ColorMode.LIGHT) Colors.Black else Colors.White

    // Map labels to their routes. Labels are what come back from onItemSelected, so they have to stay
    // unique across the whole menu, submenus included.
    val itemRoutes = mapOf(
        "Overview"              to "/learn_identify_rocks"
        , "Identification Books"  to "/learn_identify_rocks#books"
        , "Tumble Rocks"          to "/learn_tumble_rocks"
        , "Books"                 to "/learn_books"
    )

    val menuEntries = listOf(
        DropdownSubMenu(
            "Identify Rocks"
            , listOf(
                // Clicking the submenu row itself only opens it, so the page as a whole gets its own entry.
                DropdownAction("Overview")
                , DropdownAction("Identification Books")
            )
        )
        , DropdownAction("Tumble Rocks")
        , DropdownAction("Books")
    )

    Column(
        modifier = Modifier
            .fillMaxWidth()
        //.padding(32.px)
        , horizontalAlignment = Alignment.CenterHorizontally
    ) {
        DropdownMenuComponent(
            label = "Learn"
            , entries = menuEntries
            , onItemSelected = { item ->
                itemRoutes[item]?.let { route ->
                    pageContext.router.navigateTo(route)
                }

            }
            , color = textColor()
            , backgroundColor = backgroundColor
        )
    }

}

/**
 *
 *
 */
@Composable
private fun TypesOfRocksDropdownMenu() {

    val pageContext = rememberPageContext()
    val backgroundColor = if (ColorMode.current == ColorMode.LIGHT) Colors.White else Colors.Black
    //val textColor = if (ColorMode.current == ColorMode.LIGHT) Colors.Black else Colors.White

    // Map labels to their routes. Labels are what come back from onItemSelected, so they have to stay
    // unique across the whole menu, submenus included.
    val itemRoutes = mapOf(
        "Agate"                 to "/types_of_rocks/agate"
        , "Carnelian"             to "/types_of_rocks/carnelian"
        , "Chalcedony"            to "/types_of_rocks/chalcedony"
        , "Epidote"               to "/types_of_rocks/epidote"
        , "Igneous"               to "/types_of_rocks/igneous"
        , "Jasper"                to "/types_of_rocks/jasper"
        , "Metamorphic"           to "/types_of_rocks/metamorphic"
        , "Petrified Wood"        to "/types_of_rocks/PetrifiedWood"
        , "Quartz"                to "/types_of_rocks/quartz"
        , "Sedimentary"           to "/types_of_rocks/sedimentary"
        , "The Rock Cycle"        to "/types_of_rocks/the_rock_cycle"
    )

    val menuEntries = listOf(
        DropdownSubMenu(
            "Type of Rocks"
            , listOf(
                DropdownAction("The Rock Cycle")
                , DropdownAction("Igneous")
                , DropdownAction("Metamorphic")
                , DropdownAction("Sedimentary")
            )
        )
        , DropdownAction("Agate")
        , DropdownAction("Carnelian")
        , DropdownAction("Chalcedony")
        , DropdownAction("Epidote")
        , DropdownAction("Jasper")
        , DropdownAction("Petrified Wood")
        , DropdownAction("Quartz")
    )

    Column(
        modifier = Modifier
            .fillMaxWidth()
        //.padding(32.px)
        , horizontalAlignment = Alignment.CenterHorizontally
    ) {
        DropdownMenuComponent(
            label = "Types"
            , entries = menuEntries
            , onItemSelected = { item ->
                itemRoutes[item]?.let { route ->
                    pageContext.router.navigateTo(route)
                }

            }
            , color = textColor()
            , backgroundColor = backgroundColor
        )
    }

}